if ($('.section_height-100').length) {
	$(window).resize(function () {
		$('.section_height-100').css('min-height', function () {
			return $(window).height();
		});
	});

	$('.section_height-100').css('min-height', function () {
		return $(window).height();
	});
}






// WEBPACK FOOTER //
// ./_dev/blocks/section/section.js